import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UpdateChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/update-charge-point.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useUpdateChargePointContext } from '../../charge-point.context';
import { ChargePointUpdateFormStep1Controller } from '../charge-point-update-form-step-1/charge-point-update-form-step-1.controller';
import { ChargePointUpdateFormStep2Controller } from '../charge-point-update-form-step-2/charge-point-update-form-step-2.controller';

export interface ChargePointUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<UpdateChargePointModel, 'chargePointId' | 'chargePoint'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<UpdateChargePointModel, 'chargePointId' | 'chargePoint'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointUpdateFormController = (
  props: ChargePointUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useUpdateChargePointContext();

  return (
    <MultiStepFormProvider<
      Pick<UpdateChargePointModel, 'chargePointId' | 'chargePoint'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.charge-point-update.step-1.title'),
          iconName: 'electric-terminal-3',
          fields: [
            'chargePoint.identity',
            'chargePoint.authenticationLayer',
            'chargePoint.isLocked',
            'chargePoint.name',
            'chargePoint.authorizedIps',
            'chargePoint.ocppAuthenticationPassword',
          ],
          component: <ChargePointUpdateFormStep1Controller />,
        },
        {
          title: t('$.charge-point-update.step-2.title'),
          iconName: 'info-circle',
          fields: [
            'chargePoint.parkingRestrictions',
            'chargePoint.capabilities',
          ],
          component: <ChargePointUpdateFormStep2Controller />,
        },
      ]}
    />
  );
};
